import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { DocumentRequest } from '@/types'

export async function readDocumentRequest(document_request_key: string) {
  const response = await httpClient('accounting-dealer').get<DocumentRequest>(
    '/v3/file/document-request',
    {
      params: { document_request_key },
    },
  )

  return response.data
}

export function useReadDocumentRequest(document_request_key: string) {
  return useQuery({
    queryKey: ['document-request', document_request_key],
    queryFn: () => readDocumentRequest(document_request_key),
    staleTime: 0,
  })
}
